import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CalendlyEmbedProvider } from './context/CalendlyEmbedContext';
import MetaPixelRouteTracker from './components/MetaPixelRouteTracker';
import CookieDisclosure from './components/CookieDisclosure';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Login from './pages/Login';
import GroupPage from './pages/GroupPage';
import MobilePage from './pages/MobilePage';
import Trainers from './pages/Trainers';
import './App.css';

function App() {
  return (
    <CalendlyEmbedProvider>
      <Router>
        <div className="App">
          <MetaPixelRouteTracker />
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/group" element={<GroupPage />} />
            <Route path="/mobile" element={<MobilePage />} />
            <Route path="/trainers" element={<Trainers />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
          </Routes>
          <CookieDisclosure />
        </div>
      </Router>
    </CalendlyEmbedProvider>
  );
}

export default App;
